import { render, staticRenderFns } from "./CertificatePreview.vue?vue&type=template&id=3ca6d57c&scoped=true"
import script from "./CertificatePreview.vue?vue&type=script&lang=js"
export * from "./CertificatePreview.vue?vue&type=script&lang=js"
import style0 from "./CertificatePreview.vue?vue&type=style&index=0&id=3ca6d57c&prod&scoped=true&lang=css"
import style1 from "./CertificatePreview.vue?vue&type=style&index=1&id=3ca6d57c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6d57c",
  null
  
)

export default component.exports